import { SvgIcon, SvgIconProps } from '@mui/material';

const ServicesIcon = (props: SvgIconProps) => {
  return (
    <SvgIcon {...props}>
      <svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path
          d="M0.667969 17.5512V4.21782H5.66797V0.884491H12.3346V4.21782H17.3346V17.5512H0.667969ZM2.33464 15.8845H15.668V5.88449H2.33464V15.8845ZM7.33464 4.21782H10.668V2.55116H7.33464V4.21782ZM8.16797 11.7178V14.2178H9.83463V11.7178H12.3346V10.0512H9.83463V7.55116H8.16797V10.0512H5.66797V11.7178H8.16797Z"
          fill="var(--mui-palette-text-secondary)"
        />
      </svg>
    </SvgIcon>
  );
};

export default ServicesIcon;
